<template>
	<tr class="list-item">
		<td class="receipt-date">
			<div class="placeholder"></div>
		</td>
		<td class="receipt-amount">
			<div class="placeholder"></div>
			<div class="relative">
				<spinner-new class="spinner no-shadow"></spinner-new>
			</div>
		</td>
		<td class="receipt-payment">
			<div class="placeholder"></div>
		</td>
	</tr>
</template>

<script>
import SpinnerNew from '@/components/SpinnerNew.vue';
export default {
	name: 'TRPlaceholder',
	components: {
		SpinnerNew
	}
};
</script>

<style scoped>
	.placeholder {
		height: 1rem;
		background: #f2f2f2;
		width: 100px;
	}
	.dark .placeholder {
		background: #333;
	}
	.dark .receipt-date > .placeholder {
		background: #243044;
	}
	.receipt-amount .placeholder {
		width: 75px;
	}
	.receipt-payment .placeholder {
		width: 50px;
	}
	.spinner {
		top: -1rem;
	}
	.overlay {
		background: transparent;
	}

</style>



// WEBPACK FOOTER //
// ./src/components/TrPlaceholder.vue